export default __webpack_public_path__ + "static/media/walletIcon.d56b5f8f.svg";